<style lang="scss" scoped>
.title {
  color: #333333;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
}

::v-deep .custom-labels {
  label {
    color: #333333;
    font-family: 'Open Sans';
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 16px !important;
    .text-danger {
      font-size: 0.73333rem;
    }
  }
}
.version {
  width: 366px;
  position: absolute;
  right: -366px;
  height: calc(100% - 61px);
  background: #fff;
  top: 61px;
  z-index: 100;
  transition: right 0.15s ease-in-out;
  border-left: 1px solid #ededed;
  &.open {
    right: 0;
  }
  .title {
    color: #2a374a;
    font-family: 'Open Sans';
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
    padding: 32px 32px 20px 32px;
    border-bottom: 1px solid #ededed;
    i {
      &:hover {
        color: var(--primary);
      }
    }
  }
}
</style>

<template>
  <create-layout :data="data">
    <template slot="title-bar">
      <div class="title">
        {{ data.title }}
      </div>
      <template v-if="data.parent_id === null">
        <div class="box clickable" @click="$router.push({ name: 'admin-template-update', params: { templateId: data.id } })">
          <i class="fal fa-pen"></i>
        </div>
      </template>
      <template v-else>
        <div class="box clickable" @click="$router.push({ name: 'workspace-template-update', params: { workspaceId: data.parentId, templateId: data.id } })">
          <i class="fal fa-pen"></i>
        </div>
      </template>
      <div class="box ml-auto clickable" :class="{ open: versionsOpen }" @click="versionsOpen = !versionsOpen">
        <i class="fal fa-code-branch"></i>
      </div>
      <dropdown-layout ref="dropdown" class="box border-left-0 clickable position-relative">
        <template v-slot:handle>
          <i class="fal fa-ellipsis-v fa-2x"></i>
        </template>
        <template v-slot:items>
          <div class="item fs-15 d-flex fw-n ff-l" @click.stop="duplicate()">
            <i class="fal fa-folders mr-15 my-auto"></i>
            Duplicate template
          </div>
          <div class="item fs-15 text-danger d-flex fw-n ff-l" @click.stop="remove()">
            <i class="fal fa-trash mr-15 my-auto"></i>
            Verwijder template
          </div>
        </template>
      </dropdown-layout>
      <div class="box border-left-0 border-right-0 pr-0">
        <a href="#" class="btn btn-primary" @click="submit()">Wijzigingen opslaan</a>
      </div>
    </template>
    <template slot="side-bar">
      <el-form class="w-100" :error="server_error" :loading="loading" :success="success" :button-text="`${$options.name}.button`">
        <el-group
          v-for="(group, index) in data.groups"
          :key="`group_${index}_${data.groups[index].questions.length}`"
          :data="group"
          :index="index"
          :name="`Group ${index + 1}`"
          @group-updated="handleGroupUpdated"
          @group-removed="handleGroupRemoved"
          @question-added="addQuestionToGroup(index)"
          @question-updated="handleQuestionUpdated"
          @question-removed="handleRemoveQuestion"
        ></el-group>
        <template slot="footerLeft">
          <a href="javascript:void(0)" class="btn btn-primary" @click="addGroup">
            <i class="fal fa-plus mr-8"></i>
            Groep
          </a>
        </template>
        <template slot="footerRight">
          &nbsp;
        </template>
      </el-form>
      <div class="version" :class="{ open: versionsOpen }">
        <div class="title d-flex justify-content-between align-items-center">
          Eerdere versies
          <i class="fal fa-times c-pointer" @click="versionsOpen = !versionsOpen"></i>
        </div>
      </div>
    </template>
  </create-layout>
</template>

<script>
import DropdownLayout from '@/layouts/dropdown';

import HasForm from '@/components/forms/has-form';
import CreateLayout from './create-layout';
import RemovePopup from '@/popups/general/remove';

export default {
  name: 'views.admin.templates-groups',

  mixins: [HasForm],

  props: {
    type: {
      required: false,
      default: 'admin',
    },
    template: {
      required: true,
    },
  },

  components: {
    CreateLayout,
    DropdownLayout,
    ElForm: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElForm'),
    ElGroup: () => import(/* webpackChunkName: "elements" */ '@/components/elements/templates/group'),
  },

  data: vm => ({
    versionsOpen: false,
    data: JSON.parse(JSON.stringify(vm.template)),
  }),

  methods: {
    remove() {
      this.$modal.show(RemovePopup, { onSuccess: this.handleRemoveOnSuccess, modelId: this.template.id, modelTitle: this.template.title, type: 'template' }, { adaptive: true, height: 'auto', width: '400' });
      this.$refs.dropdown.open = false;
    },
    handleRemoveOnSuccess() {
      if (this.type === 'workspace' && this.data.parent_id !== null) {
        this.$router.push({ name: 'workspace-templates', params: { workspaceId: this.data.parent_id } }).catch(e => {});
        return;
      }
      this.$router.push({ name: 'admin-templates' });
    },
    submit() {
      this.loading = true;
      this.$store
        .dispatch('template/createOrUpdateGroup', this.data)
        .then(() => {
          this.$toasted.show(this.toastHtml('Template updated!'), {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
          });

          if (this.type === 'workspace' && this.data.parent_id !== null) {
            this.$router.push({ name: 'workspace-templates', params: { workspaceId: this.data.parent_id } }).catch(e => {});
            return;
          }

          this.$router.push({ name: 'admin-templates' });
        })
        .catch(e => this.handleError(e));
    },
    addGroup() {
      this.data.groups.push({
        title: '',
        open: true,
        dirty: true,
        questions: [{ label: '', type: 'text' }],
      });
    },
    handleGroupUpdated(groupIndex) {
      this.$set(this.data.groups[groupIndex], 'dirty', true);
    },
    handleGroupRemoved(groupIndex) {
      if (this.data.hasOwnProperty('id') && this.data.groups.length !== 0 && this.data.groups[groupIndex].hasOwnProperty('id')) {
        this.$store.dispatch('template/deleteGroup', { templateId: this.data.id, groupId: this.data.groups[groupIndex].id });
      }
      this.data.groups.splice(groupIndex, 1);
    },
    addQuestionToGroup(index) {
      let emptyQuestion = { label: '', type: 'text', dirty: true };

      if (this.data.groups[index].hasOwnProperty('questions')) {
        this.data.groups[index].questions.push(emptyQuestion);
        return;
      }
      this.$set(this.data.groups[index], 'questions', [emptyQuestion]);
    },
    handleQuestionUpdated(groupIndex, questionIndex, question) {
      question.dirty = true;
      this.$set(this.data.groups[groupIndex].questions, questionIndex, question);
    },
    handleRemoveQuestion(groupIndex, questionIndex) {
      if (this.data.hasOwnProperty('id') && this.data.groups.length !== 0 && this.data.groups[groupIndex].hasOwnProperty('id') && this.data.groups[groupIndex].questions.length !== 0 && this.data.groups[groupIndex].questions[questionIndex].hasOwnProperty('id')) {
        this.$store.dispatch('template/deleteQuestion', { templateId: this.data.id, groupId: this.data.groups[groupIndex].id, questionId: this.data.groups[groupIndex].questions[questionIndex].id });
      }
      this.data.groups[groupIndex].questions.splice(questionIndex, 1);
    },
    duplicate() {
      const id = this.data.id;
      this.$store.dispatch('template/duplicate', id).then(template => {
        this.$toasted.show(this.toastHtml('Template duplicated!'), {
          theme: 'outline',
          position: 'bottom-right',
          duration: 5000,
        });
        this.$router.push({ name: 'admin-template-update', params: { templateId: template.id } });
      });
    },
  },
};
</script>
